import React from 'react';
import Markdown, { type Components } from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { type ChatMessageProps } from './types';

// react-markdown emits raw block elements (<p>, <ul>, <ol>) that inherit the browser's
// default ~16px vertical margins, which show up as an odd gap at the top/bottom of a
// chat bubble and oversized gaps between paragraphs on multi-line responses. Override
// just the element renderers (no wrapping DOM) so the bubble layout is untouched.
const markdownComponents: Components = {
  p: ({ children }) => <p style={{ margin: '0 0 0.4em' }}>{children}</p>,
  ul: ({ children }) => <ul style={{ margin: '0.2em 0', paddingInlineStart: '1.4em' }}>{children}</ul>,
  ol: ({ children }) => <ol style={{ margin: '0.2em 0', paddingInlineStart: '1.4em' }}>{children}</ol>,
  li: ({ children }) => <li style={{ margin: '0.15em 0' }}>{children}</li>,
};

export const TextMessage: React.FC<ChatMessageProps> = ({ part, index, isUserMessage }) => {
  const text = part.text as string;
  // Suppress empty/whitespace-only text to prevent empty chat bubbles.
  // Models often emit "\n\n\n" before tool calls which would render as blank space.
  if (!text?.trim()) return null;
  if (isUserMessage && text.startsWith('{') && text.endsWith('}')) {
    return <span key={index} style={{ opacity: 0.7, fontSize: '13px' }}>✓ Form submitted</span>;
  }
  const displayText = isUserMessage ? text.replace(/^\[Context: [^\]]*\]\n\n/, '') : text;
  return isUserMessage
    ? <span key={index}>{displayText}</span>
    : <Markdown components={markdownComponents} key={index} remarkPlugins={[remarkGfm]}>{displayText}</Markdown>;
};
